<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Asociar Notas de Salida
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5069]" [permissionType]="permissionType.ALL"
				[(ngModel)]="tab" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5069]" [permissionType]="permissionType.ALL">
				<i class="fa fa-file-signature"></i>Nota de Salida → Venta
			</label>

			<input type="radio" name="pcss3t" [appCheckPermission]="[5069]" [permissionType]="permissionType.ALL"
				[(ngModel)]="tab" [value]="1" checked id="tab2">
			<label for="tab2" [appCheckPermission]="[5069]" [permissionType]="permissionType.ALL">
				<i class="fa fa-certificate"></i>Nota de Salida → COA
			</label>

		</div>
		
		
		<div class="row" [hidden]="tab!=0">
			<div class="col" id="list-container">
				<app-association-exit-note-sale *ngIf="tab==0"></app-association-exit-note-sale>
			</div>
		</div>
		<div class="row" [hidden]="tab!=1">
			<div class="col" id="list-container">
				<app-association-exit-note-coa *ngIf="tab==1"></app-association-exit-note-coa>
			</div>
		</div>
	</div>

</div>